import {Checkbox, DataStatus} from 'platform/components';
import {VStack} from 'platform/foundation';
import {useFormatNumber} from 'platform/locale';

import {isNil} from 'ramda';

import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps} from 'shared/web';

import {useSourcingTopSelling} from '../../../../../../../hooks/useSourcingTopSelling';
import {useMakeModelFilter} from '../../../../../hooks/useMakeModelFilter';
import type {TopSellingType} from '../types/TopSellingType';

export function TopSellingCheckboxList(props: TestIdProps) {
  const {allSelectedModels, selectModel, unselectModel} = useMakeModelFilter();

  const {currentData: topSelling, isFetching, isError} = useSourcingTopSelling();

  const formatNumber = useFormatNumber();

  const handleClickTopSelling = (item: TopSellingType, isSelected: boolean) => {
    if (!item.model?.key) {
      return;
    }

    if (isSelected) {
      selectModel(item.model.key);
    } else {
      unselectModel(item.model.key);
    }
  };

  return (
    <DataStatus
      isLoading={isFetching && isNil(topSelling)}
      isError={isError}
      isEmpty={topSelling?.length === 0}
      emptyMessage={i18n.t('page.filters.labels.noTopSelling')}
      minHeight={24}
    >
      <VStack spacing={2}>
        {topSelling &&
          topSelling.map((item, index) => {
            const isSelected = !!item.model?.key && allSelectedModels.includes(item.model?.key);

            return (
              <Checkbox
                key={item.model?.key}
                name={`topSelling.${item.model?.key}`}
                label={`${index + 1}. ${item.make?.translation} ${
                  item.model?.translation
                } (${formatNumber(item?.count ?? 0, 0)})`}
                value={isSelected}
                onChange={(e) => handleClickTopSelling(item, e)}
                data-testid={suffixTestId(`topSelling-${item.model?.key}`, props)}
              />
            );
          })}
      </VStack>
    </DataStatus>
  );
}
